module.exports = __webpack_public_path__ + "assets/b880bf2b9c36baa4e41a012d99bab057.mp3";